import { isFunction } from 'lodash';
import { isBrowser } from '@zapier/common-utils';
import { getFullStory } from '.';

// See fullstory.html for details about when FS gets installed for a user.
export const isFullStoryInstalled = () =>
  isBrowser() && !!window.FS && isFunction(getFullStory().identify);
